import type { SkillView } from "../../state/connections";
import { isBuiltInSkill } from "./pluginContent";

export const SKILL_FILTERS = [
  { id: "all", label: "All" },
  { id: "system", label: "System" },
  { id: "organization", label: "Organisation" },
  { id: "jurisdiction", label: "Jurisdiction" },
] as const;
export type SkillFilter = (typeof SKILL_FILTERS)[number]["id"];

export function getSkillSource(
  skill: Pick<SkillView, "id" | "scope">,
): Exclude<SkillFilter, "all"> {
  return isBuiltInSkill(skill.id) || skill.scope === "global" ? "system" : skill.scope;
}

export const SKILL_SOURCE_LABEL = {
  system: "System",
  organization: "Organisation",
  jurisdiction: "Jurisdiction",
} as const;

export const SKILL_FILTER_DESCRIPTION: Record<SkillFilter, string> = {
  all: "Available to use in chat. Amoreg can follow a skill when it fits your task.",
  system: "Included with Amoreg for common tasks such as documents and spreadsheets.",
  organization:
    "Shared methods created for your organisation. Administrators can create and update them in chat.",
  jurisdiction:
    "Methods for jurisdiction-specific regulatory work. Check the description for when each applies.",
};

/** What "Create skill" puts in the composer; the agent drafts and saves it (admins only). */
export const CREATE_SKILL_PROMPT =
  "Create a new skill for our organization, following the skill-authoring skill: " +
  "survey the existing skill library first, agree the trigger with me, then draft the " +
  "name, slug, trigger-focused description, and full body. The skill should ";

export function filterSkills(
  skills: ReadonlyArray<SkillView>,
  filter: SkillFilter,
  query: string,
): ReadonlyArray<SkillView> {
  const normalized = query.trim().toLocaleLowerCase();
  return skills.filter((skill) => {
    const source = getSkillSource(skill);
    return (
      (filter === "all" || source === filter) &&
      (!normalized ||
        [skill.name, skill.description, skill.slug, skill.category, SKILL_SOURCE_LABEL[source]]
          .filter((value) => typeof value === "string")
          .join(" ")
          .toLocaleLowerCase()
          .includes(normalized))
    );
  });
}
